import architecture from './architecture.json';
import mountains from './mountains.json';
import nature from './nature.json';
import people from './people.json';
import portrait from './portrait.json';
import traveling from './traveling.json';
import trekking from './trekking.json';
import wildlife from './wildlife.json';
import drone from './drone.json';
import motorbike from './motorbike.json';

export default {
  ...motorbike,
  ...traveling,
  ...portrait,
  ...wildlife,
  ...drone,
  ...people,
  ...nature,
  ...trekking,
  ...architecture,
  ...mountains,
};
